import { httpClient } from "@/services";

export default {
	state: {
		truckNotesFilter: null,
		truckNotesList: []
	},
	mutations: {
		updateTruckNotes(state, { filter, list }) {
			state.truckNotesFilter = filter;
			state.truckNotesList = list;
		}
	},
	actions: {
		async onTruckNotes({ commit }, truckId) {
			try {
				const { data } = await httpClient.post(`trucks/notes/${ truckId }`);
				if (data && !data.status) {
					commit('updateTruckNotes', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onTruckNotesCreate({ dispatch }, { truckId, values }) {
			const { id, notes } = values;
			const url = id ? `/trucks/notes/${ id }/update` : `/trucks/notes/${ truckId }/store`;
			const message = id ? "Updated notes item" : "Created notes item";

			try {
				const { data } = await httpClient.post(url, { notes });
				if (data && data.status) {
					dispatch('setAlert', { type: "success", message });
					dispatch('onTruckNotes', truckId);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onTruckNotesListFilter({ commit }, { id, filters }) {
			try {
				const { data } = await httpClient.post(`/trucks/notes/${ id }`, filters);
				if (data && !data.status) {
					commit('updateTruckNotes', data);
				}
			} catch (e) {
				console.error(e);
			}
		},
		async onTruckNotesRemove({ dispatch }, { id, truckId }) {
			const { data } = await httpClient.delete(`/trucks/notes/${ id }`);

			if (data && data.status) {
				dispatch('setAlert', { type: "success", message: "Remove notes item" });
				dispatch('onTruckNotes', truckId);
			}
		}
	},
	getters: {
		truckNotesFilter: s => s.truckNotesFilter,
		truckNotesList: s => s.truckNotesList
	}
};
